<button (click)="showLegend=true" class="button_highlighted cyan floatRight"
        hisImage="INFORMATION" [title]="'cs.sys.hisng.gridcalendar.legend.button.title.openLegend' | hisUi">
    {{'cs.sys.hisng.gridcalendar.legend.button.text.openLegend' | hisUi}}
</button>

<p-drawer [(visible)]="showLegend" position="right" [style]="{width:'unset'}">
    <ng-template pTemplate="header">
        <h2>{{'cs.sys.hisng.gridcalendar.legend.header' | hisUi}}</h2>
    </ng-template>

    <div class="clearAndSpace"></div>

    <p-table [value]="legendEntries">
        <ng-template pTemplate="header">
            <tr>
                <th>{{'cs.sys.hisng.gridcalendar.legend.column.event' | hisUi}}</th>
                <th>{{'cs.sys.hisng.gridcalendar.legend.column.description' | hisUi}}</th>
            </tr>
        </ng-template>

        <ng-template pTemplate="body" let-legendEntry>
            <tr>
                <td style="padding: 0.2rem 0.4rem;">
                    <div class="legendCell" [ngClass]="legendEntry.css">
                        <span class="legendAbbreviation">
                            {{ gridCalendarUtil.getText( legendEntry.abbreviation ) }}
                        </span>
                    </div>
                </td>
                <td>{{ gridCalendarUtil.getText( legendEntry.description ) }}</td>
            </tr>
        </ng-template>
    </p-table>
</p-drawer>